import { Button, Checkbox, Drawer, Form, Input, Select, Spin, Tag, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronDown, ChevronLeft, ChevronUp, CloseIcon, Edit } from '../../assets/icons';
import BankAccountModal from '../../components/LinkBankAccount/BankAccountModal';
import { Images } from '../../config/images';
import ResetPin from '../../pages/Account/Profile/Modals/ResetPin';
import { formatePhoneNumber } from '../../utils/formatPhoneNumber';
import { getBankLogo } from '../../utils/getBankLogo';
import { AGREEMENT_ACCEPTANCES } from '../../utils/policy.constants';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import FloatingLabel from '../FloatingLabel/FloatingLabel';
import ListingAgreement from '../ListingAgreement/ListingAgreement';
import PaymentDetailOption from '../PaymentDetailOption/PaymentDetailOption';
import PinDrawerWithoutButton from '../PinDrawerWithoutButton/PinDrawerWithoutButton';

const QuickBuyInitialDrawer = (props) => {
  const { quickBuyPropertyData, quickByOptions = {}, featchData = () => {} } = props;
  const [arrowUp, setArrowUp] = useState(false);
  const {
    loading = false,
    pin = '',
    walletsData = [],
    agreementData = '',
    totalInvestment = '',
    totalPurchase = '',
    equity = '',
    numberOfShare = '',
    resetPin = '',
    checkbox1 = false,
    checkbox2 = false,
    daysReamaining = '',
    isTurmAndCondistion = false,
    isMaxRangeError = false,
    isMinRangeError = false,
    sharesRemainingToPurchase = 0,
    selectedPaymentMethod = {},
    isEditPayment = false,
    minButtonValue = 0,
    handleVerifyPin = () => {},
    handlePlaceOrder = () => {},
    handleForgotPin = () => {},
    handleAgreeAndContinue = () => {},
    setNumberOfShare = () => {},
    setResetPin = () => {},
    setCheckbox1 = () => {},
    setCheckbox2 = () => {},
    setPin = () => {},
    setIsTurmAndCondistion = () => {},
    handleSelectPaymentMethod = () => {},
    setIsEditPayment = () => {},
    handleAddBank = () => {},
    handleUpdateBanksList = () => {},
    handleCancelBuyOrder = () => {},
    setLoading = () => {},
    isTOSModal,
    onTOSAgreementSuccess,
    onTOSModalClose,
  } = quickByOptions;
  const userProfileData = useSelector((state) => state.userData.userData);
  const cancelOrderLoading = useSelector((state) => state.initialOffering.cancelBuyOrderLoading);
  const phoneNumber = ['+1', formatePhoneNumber(userProfileData?.phoneNumber)];
  const [isTextSelected, setIsTextSelected] = useState(false);

  const [bankModalOpen, setBankModalOpen] = useState(false);
  const linkText = 'My Account>Account Balances';
  const linkPath = '/account/transactions';
  const bankVerificationText = 'My Account>Payments';
  const bankVerificationPath = '/account/payment';
  const openLink = () => {
    window.location.href = linkPath;
  };

  const openPaymentsLink = () => {
    window.location.href = bankVerificationPath;
  };

  useEffect(() => {
    return () => {
      setIsEditPayment(false);
    };
  }, [selectedPaymentMethod]);
  return (
    <>
      <BankAccountModal
        bankModalOpen={bankModalOpen}
        setBankModalOpen={(value) => setBankModalOpen(value)}
        onSuccess={(value) => handleAddBank(value)}
        onClose={() => setIsEditPayment(false)}
        handleUpdateBanksList={handleUpdateBanksList}
        shouldUpdateList
      />
      <PinDrawerWithoutButton
        onCancel={() => {
          props.modalState();
          setPin(undefined);
        }}
        open={props.open === 'StepOne'}
        pin={pin}
        loading={loading}
        handleForgotPin={handleForgotPin}
        setPin={setPin}
        setLoading={setLoading}
        onSuccess={handleVerifyPin}
      />
      <ResetPin phoneNumber={phoneNumber || ''} mail={userProfileData?.email || ''} setOpen={resetPin} setClose={() => setResetPin(false)} />
      <Drawer
        className='buy-order footer-shadow quickbuy--drawer'
        width='100%'
        title={<p className='subhead-2 mb-0 ml-40 text-center'>Create buy order</p>}
        onClose={() => props.modalState()}
        open={props.open === 'StepTwo'}
        closeIcon={<CloseIcon />}
        footer={
          <Button
            type='primary'
            className='w-100'
            disabled={
              isMaxRangeError ||
              isMinRangeError ||
              numberOfShare === '0' ||
              !numberOfShare ||
              Number(numberOfShare) % 1 !== 0 ||
              Number(numberOfShare) <= 0 ||
              (Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase) &&
                Number(numberOfShare) > Number(quickBuyPropertyData?.sharesRemaining))
            }
            onClick={() => props.modalState('StepThree')}
          >
            Preview order
          </Button>
        }
      >
        <div className='buy-order-header'>
          <div className='header__img'>
            {quickBuyPropertyData?.images?.image1 ? (
              <LazyLoadImage
                onError={(element) => {
                  element.target.src = Images.noPropertyFoundImage;
                }}
                src={quickBuyPropertyData?.images?.image1}
              />
            ) : (
              <img src={Images.noPropertyFoundImage} alt='' />
            )}
          </div>
          <div className='header__content'>
            <p className='subhead-2 text-copper mb-0'>{quickBuyPropertyData?.name || ''}</p>
            <div className='name-type text-taupe'>
              <span className='fz-12'>{`${quickBuyPropertyData?.city || ''}, ${quickBuyPropertyData?.state || ''}`}</span>
              <span className='fz-12 mr-4 ml-4'>•</span>
              <span className='fz-12'>{quickBuyPropertyData?.propertyType || ''}</span>
            </div>
            <div className='share-details mt-12'>
              <div className='block'>
                <span className='text-taupe-80'>Shares remaining</span>
                <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(quickBuyPropertyData?.sharesRemaining || '')}</span>
              </div>
              {/* Comment out for CR change to hide investor count */}
              {/* <div className='block'>
                <span className='text-taupe-80'>Investors</span>
                <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(quickBuyPropertyData?.investors || '')}</span>
              </div> */}
              <div className='block'>
                <span className='text-taupe-80'>Share price</span>
                <span className='subhead-3'>{`$ ${getUsCurrencyFormat(quickBuyPropertyData?.perSharePrice || '')}`}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='buy-content'>
          <FloatingLabel label='Number of shares' inputId='shares' inputValue={numberOfShare} alwaysBig>
            <Form.Item
              className='mt-10 mb-12'
              validateStatus={
                (isMaxRangeError ||
                  isMinRangeError ||
                  Number(numberOfShare) % 1 !== 0 ||
                  (Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase) &&
                    Number(numberOfShare) > Number(quickBuyPropertyData?.sharesRemaining))) &&
                'error'
              }
              help={
                Number(numberOfShare) % 1 !== 0
                  ? 'Decimal numbers are not allowed.'
                  : Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase) &&
                    Number(numberOfShare) > Number(quickBuyPropertyData?.sharesRemaining)
                  ? 'You have exceeded the Buy out limit.(i.e Shares remaining)'
                  : isMaxRangeError
                  ? 'You have exceeded the Buy out limit.(i.e more than 9.8%)'
                  : isMinRangeError && `You have to buy minimum  ${minButtonValue.toString()} share.`
              }
            >
              <Input
                value={numberOfShare}
                inputMode='numeric'
                pattern='[0-9]*'
                onChange={(e) => setNumberOfShare(e.target.value.replace(/[^0-9]/g, ''))}
                onSelect={(e) => {
                  window.getSelection().toString().length > 0 ? setIsTextSelected(true) : setIsTextSelected(false);
                }}
                onKeyPress={(event) => {
                  if ((Number(event.target.value) > Number(sharesRemainingToPurchase.toFixed(0)) || !/[0-9]/.test(event.key)) && !isTextSelected) {
                    event.preventDefault();
                  }
                }}
                id='share'
              />
            </Form.Item>
          </FloatingLabel>
          <div className='mb-20 buy-tags'>
            <Tag
              className={numberOfShare.toString() === minButtonValue.toString() && 'ant-tag__selected'}
              onClick={() => setNumberOfShare(minButtonValue.toString() || '0')}
            >
              {`min: ${minButtonValue.toString() || 0}`}
            </Tag>
            <Tag
              className={
                Number(quickBuyPropertyData?.sharesRemaining) < 100 || Number(sharesRemainingToPurchase) < 100
                  ? 'ant-tag-disabled'
                  : numberOfShare?.toString() === '100' && 'ant-tag__selected'
              }
              onClick={() => {
                Number(quickBuyPropertyData?.sharesRemaining) > 100 && Number(sharesRemainingToPurchase) > 100 && setNumberOfShare('100');
              }}
            >
              most popular: 100
            </Tag>
            <Tag
              className={
                Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase)
                  ? 'ant-tag-disabled'
                  : numberOfShare.toString() === sharesRemainingToPurchase.toFixed(0).toString() && 'ant-tag__selected'
              }
              onClick={() => {
                Number(quickBuyPropertyData?.sharesRemaining) > Number(sharesRemainingToPurchase) &&
                  setNumberOfShare(sharesRemainingToPurchase.toString() || '0');
              }}
            >
              {`max (9.8%): ${sharesRemainingToPurchase.toFixed(0) || 0}`}
            </Tag>
          </div>
          <div className='mb-20 basic-info'>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Total Investment (USD)</span>
              <span className='basic-info__item__value fw-600'>{`$ ${getUsCurrencyFormat(totalInvestment || 0)}`}</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Platform Fee</span>
              <span className='basic-info__item__value'>$2.5</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Total Purchase (USD)</span>
              <span className='basic-info__item__value fw-600'>{`$ ${getUsCurrencyFormat(totalPurchase || 0)}`}</span>
            </div>
            <div className='basic-info__item'>
              <Tooltip title='The equity you own in a property is calculated by dividing the shares you own by the total number of shares available. The maximum equity percentage you can have in a property is 9.8% due to SEC regulations.'>
                <span className='basic-info__item__name underline'>Equity</span>
              </Tooltip>
              <span className='basic-info__item__value'>{`${equity || ''} %`}</span>
            </div>
            <div className='basic-info__item'>
              <Tooltip title='The duration of an order for an initial offering will last until the property’s funding period concludes. The funding period may conclude before the 90 day allotment is over if the property reaches its goal early. At that time your order will be executed. If the property fails to reach its goal in this period, your funds will be returned to you.'>
                <span className='basic-info__item__name underline'>Duration</span>
              </Tooltip>
              <span className='basic-info__item__value'>{`${daysReamaining || ''} days remaining`}</span>
            </div>
          </div>
        </div>
      </Drawer>

      <Drawer
        className='review-buy-order footer-shadow quickbuy--drawer'
        width='100%'
        title={
          <>
            <ChevronLeft className='cursor-pointer' onClick={() => props.modalState('StepTwo')} />
            <span className='subhead-2 mb-0 ml-24 text-center title'>Review buy order</span>
          </>
        }
        onClose={() => props.modalState()}
        open={props.open === 'StepThree'}
        closeIcon={<CloseIcon />}
        footer={
          <Button
            disabled={!isTurmAndCondistion || selectedPaymentMethod?.bankVerificationStatus !== 'Verified'}
            loading={loading}
            type='primary'
            className='w-100'
            onClick={() => handlePlaceOrder()}
          >
            Place order
          </Button>
        }
      >
        <p className='fw-600 fz-16'>Investment details</p>
        <div className='d-flex flex-column g-16 fz-14'>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Shares</span>
            <span>{numberOfShare}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Price per Share</span>
            <span>{`$${getUsCurrencyFormat(quickBuyPropertyData?.perSharePrice || 0)}`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Total Investment (USD)</span>
            <span className='fw-600'>{`$${getUsCurrencyFormat(totalInvestment || 0)}`}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Platform Fee</span>
            <span>{`$${getUsCurrencyFormat(2.5 || 0)}`}</span>
          </div>
        </div>
        <hr className='mt-16 mb-16' />
        <div className='d-flex flex-column g-16 fz-14'>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Total Purchase (USD):</span>
            <span className='fw-600'>{`$${getUsCurrencyFormat(totalPurchase || 0)}`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <Tooltip title='The equity you own in a property is calculated by dividing the shares you own by the total number of shares available. The maximum equity percentage you can have in a property is 9.8% due to SEC regulations.'>
              <span className='text-taupe-80 underline'>Equity</span>
            </Tooltip>
            <span>{`${equity || ''}%`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <Tooltip title='The duration of an order for an initial offering will last until the property’s funding period concludes. The funding period may conclude before the 90 day allotment is over if the property reaches its goal early. At that time your order will be executed. If the property fails to reach its goal in this period, your funds will be returned to you.'>
              <span className='text-taupe-80 underline'>Duration</span>
            </Tooltip>
            <span>{`${daysReamaining || ''} days remaining`}</span>
          </div>
        </div>
        <p className='fw-600 mt-32 fz-16'>Payment details</p>
        {!!isEditPayment ? (
          <FloatingLabel label='Payment method' inputId='bankSelect' inputValue={selectedPaymentMethod.id} alwaysBig>
            <>
              <div id='bank-anchor' />
              <Form.Item name='bankSelect' className='mb-0'>
                <Select
                  id='bankSelect'
                  onChange={(value) => (value !== -1 ? handleSelectPaymentMethod(value) : setBankModalOpen(true))}
                  defaultValue={selectedPaymentMethod.id}
                  value={selectedPaymentMethod.id}
                  disabled={loading}
                  getPopupContainer={() => document.getElementById('bank-anchor')}
                  menuItemSelectedIcon={<CheckCircle verticalAlign='-8px' />}
                  onDropdownVisibleChange={() => setArrowUp(!arrowUp)}
                  suffixIcon={arrowUp ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                >
                  {walletsData?.map((item) => (
                    <Select.Option
                      key={item?.id}
                      value={item.id}
                      disabled={item?.bankVerificationStatus !== 'Verified' && item?.sourceType !== 'add new'}
                    >
                      <PaymentDetailOption item={item} totalInvestment={totalInvestment} />
                    </Select.Option>
                  ))}
                </Select>
                {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
                  <div className='pt-10 error-text'>
                    <span style={{ cursor: 'pointer' }} onClick={openLink}>
                      Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                    </span>
                  </div>
                )}
                {selectedPaymentMethod?.bankVerificationStatus !== 'Verified' && (
                  <div className='pt-10 error-text'>
                    <span style={{ cursor: 'pointer' }} onClick={openPaymentsLink}>
                      Selected Bank has not been verified yet to initiate the transaction. Please go to{' '}
                      {<a href={bankVerificationPath}>{bankVerificationText}</a>} to verify your bank.
                    </span>
                  </div>
                )}
              </Form.Item>
            </>
          </FloatingLabel>
        ) : (
          <>
            <div className='d-flex g-8 align-items-center'>
              {getBankLogo(selectedPaymentMethod?.brandName)}
              <span className='fz-16'>
                {selectedPaymentMethod?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : selectedPaymentMethod?.brandName || ''}
              </span>
              {selectedPaymentMethod?.sourceType !== 'Wallet' && (
                <span className='text-taupe-80 fz-16'>{`*** ${selectedPaymentMethod?.lastFourDigit || ''}`}</span>
              )}
              {selectedPaymentMethod?.sourceType === 'Wallet' &&
              selectedPaymentMethod?.balance !== undefined &&
              selectedPaymentMethod?.balance !== null ? (
                totalInvestment > selectedPaymentMethod?.balance ? (
                  <span className='text-taupe-80 fz-16 error-text'>Insufficient balance</span>
                ) : (
                  <span className='text-taupe-80 fz-16'>{`$${Number(selectedPaymentMethod?.balance)
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}</span>
                )
              ) : null}
              <Edit className='ml-auto cursor-pointer' size={20} color='#726460' onClick={() => setIsEditPayment(true)} />
            </div>
            {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
              <div className='pt-10 error-text'>
                <span style={{ cursor: 'pointer' }} onClick={openLink}>
                  Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                </span>
              </div>
            )}
            {selectedPaymentMethod?.bankVerificationStatus !== 'Verified' && (
              <div className='pt-10 error-text'>
                <span style={{ cursor: 'pointer' }} onClick={openPaymentsLink}>
                  Selected Bank has not been verified yet to initiate the transaction. Please go to{' '}
                  {<a href={bankVerificationPath}>{bankVerificationText}</a>} to verify your bank.
                </span>
              </div>
            )}
          </>
        )}
        <div className='d-flex mt-48'>
          <Checkbox
            disabled={loading}
            checked={isTurmAndCondistion}
            onChange={(value) => setIsTurmAndCondistion(value.target.checked)}
            className='mr-16'
          />
          <span className='cursor-pointer fz-16'>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>I have read and accept the </span>
            <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
              Terms of Use
            </Link>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, the </span>
            <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
              Regulation A Investment Disclosure
            </Link>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, and </span>
            <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
              Privacy Policy
            </Link>
            .
          </span>
        </div>
      </Drawer>

      <Drawer
        className='agreement footer-shadow quickbuy--drawer'
        width='100%'
        open={props.open === 'StepFour'}
        title={
          <>
            <ChevronLeft
              className='cursor-pointer'
              onClick={async () => {
                !loading && (await handleCancelBuyOrder());
                props.modalState('StepThree');
              }}
            />
            <span className='subhead-2 mb-0 ml-24 text-center title'>Purchase Agreement</span>
          </>
        }
        closeIcon={
          <CloseIcon
            disabled={loading}
            onClick={async () => {
              !loading && (await handleCancelBuyOrder());
              props?.modalState();
            }}
          />
        }
        footer={
          <Button loading={loading} type='primary' className='w-100' disabled={!checkbox1 || !checkbox2} onClick={() => handleAgreeAndContinue()}>
            Agree to terms
          </Button>
        }
        centered
      >
        <Spin spinning={cancelOrderLoading}>
          <div className='agreement-content fz-14'>
            <div dangerouslySetInnerHTML={{ __html: agreementData }} />
            <div className='checks'>
              <Checkbox className='ml-8' checked={checkbox1} onChange={() => setCheckbox1(!checkbox1)} disabled={loading}>{`I attest that I am ${
                userProfileData?.firstName || ''
              } ${userProfileData?.lastName || ''} and I understand that the signature herein is a legal representation of my own.`}</Checkbox>

              <Checkbox disabled={loading} checked={checkbox2} onChange={() => setCheckbox2(!checkbox2)} className='ml-0'>
                {AGREEMENT_ACCEPTANCES.AGREE_SUBSCRIPTION_AGREEMENT}
              </Checkbox>
            </div>
          </div>
        </Spin>
      </Drawer>

      <Drawer
        className='success footer-shadow quickbuy--drawer'
        width='100%'
        title={false}
        onClose={() => {
          featchData();
          props.modalState();
        }}
        open={props.open === 'success'}
        closable={false}
        footer={false}
      >
        <div className='mb-16 success__vector'>
          <img src={Images.success} alt='success vector art' />
        </div>
        <h4 className='success__title fz-24'>You’re an investor!</h4>
        <p className='mb-48 text-taupe fz-16'>
          {`You have successfully purchased ${numberOfShare || 0} share(s) ($${getUsCurrencyFormat(
            quickBuyPropertyData?.perSharePrice || 0
          )} each) of ${quickBuyPropertyData?.name || ''}. You may track this investment in your`}
          <Link className='text-copper' to='/portfolio'>
            Portfolio
          </Link>
          .
        </p>
        <Button
          type='primary'
          className='w-100'
          onClick={() => {
            props.modalState();
            featchData();
          }}
        >
          Done
        </Button>
      </Drawer>

      {isTOSModal && <ListingAgreement isOpen={isTOSModal} onClose={onTOSModalClose} onAgreementAccept={onTOSAgreementSuccess} />}
    </>
  );
};

export default QuickBuyInitialDrawer;
